import Icon from "@/components/Icon";

/** Réglages de l'espace enseignant — coquille volontairement minimale pour ce premier
 *  jet (l'item de navigation existe, le contenu s'étoffera ensuite). Les réglages de
 *  compte (mot de passe, profil) vivent dans l'IdP : compte.orense.ch. */
export default function InstructorSettings() {
  return (
    <div>
      <p style={styles.crumb}>Espace enseignant</p>
      <h1 style={styles.title}>Réglages</h1>
      <div style={styles.card}>
        <Icon name="locked" size={22} style={{ color: "var(--text-muted)" }} />
        <div>
          <p style={styles.line}>Les réglages de compte (mot de passe, profil) se gèrent dans ton compte orense.</p>
          <a href="https://compte.orense.ch/mon-compte" style={styles.link}>Ouvrir mon compte orense →</a>
        </div>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  crumb: { margin: 0, fontSize: 12, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: 1 },
  title: { margin: "4px 0 24px", fontSize: 26, fontWeight: 700, color: "var(--text)" },
  card: { display: "flex", alignItems: "center", gap: 16, background: "var(--bg-panel)", border: "1px solid var(--border-soft)", borderRadius: "var(--radius-lg)", padding: "20px 22px", maxWidth: 560 },
  line: { margin: "0 0 6px", fontSize: 14, color: "var(--text)" },
  link: { color: "var(--blue)", fontSize: 13.5, fontWeight: 600, textDecoration: "none" },
};
